import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';
import has from 'lodash/has';
import registerStoreModule from '~/helpers/store-helper';
import { extractProductReference } from '~/helpers/extract-helper';
import product from '~/store/modules/product';
import { WIBILONG_JS_URL, WIBILONG_CSS_URL } from '~/const/3rd';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import ProductGlide from '~/components/functional/UI/ProductGlide.vue';
import SquareImage from '~/components/atoms/Product/SquareImage.vue';
import ProductLoading from '~/components/organisms/Product/ProductLoading.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/geoloc.svg';

var CommercialRibbon = function CommercialRibbon() {
  return import(
  /* webpackChunkName: "commercial-ribbon" */
  '~/components/atoms/Global/CommercialRibbon.vue');
};

var SmartBanner = function SmartBanner() {
  return import(
  /* webpackChunkName: "smart-banner" */
  '~/components/molecules/Product/SmartBanner.vue');
};

var ThePriceSection = function ThePriceSection() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/ThePriceSection.vue');
};

var TheVariantsSection = function TheVariantsSection() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/TheVariantsSection.vue');
};

var ZoomModal = function ZoomModal() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/molecules/Product/ZoomModal.vue');
};

var ThumbnailList = function ThumbnailList() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/ThumbnailList.vue');
};

var TheEmailForm = function TheEmailForm() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/molecules/Product/TheEmailForm.vue');
};

var TheCartSection = function TheCartSection() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/TheCartSection.vue');
};

var Reinsurance = function Reinsurance() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/Reinsurance.vue');
};

var ZoomableImage = function ZoomableImage() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/molecules/Product/ZoomableImage.vue');
};

var Heart = function Heart() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/atoms/Global/Heart.vue');
};

var ProductStock = function ProductStock() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/atoms/Product/ProductStock.vue');
};

var CrossEarlyBirds = function CrossEarlyBirds() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/CrossEarlyBirds.vue');
};

var ShopTheLook = function ShopTheLook() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/ShopTheLook.vue');
};

var ProductInformation = function ProductInformation() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/ProductInformation');
};

var ProductFlags = function ProductFlags() {
  return import(
  /* webpackChunkName: "product-flags" */
  '~/components/organisms/Product/ProductFlags.vue');
};

var Olapic = function Olapic() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/Olapic.vue');
};

var StoreAvailability = function StoreAvailability() {
  return import(
  /* webpackChunkName: "product-sheet" */
  '~/components/organisms/Product/StoreAvailability.vue');
};

var ProductSeo = function ProductSeo() {
  return import(
  /* webpackChunkName: "product-seo-tracking" */
  '~/components/functional/Seo/ProductSeo.vue');
};

var OpenGraph = function OpenGraph() {
  return import(
  /* webpackChunkName: "product-seo-tracking" */
  '~/components/functional/OpenGraph/ProductOpenGraph.vue');
};

var JsonLd = function JsonLd() {
  return import(
  /* webpackChunkName: "product-seo-tracking" */
  '~/components/functional/JsonLD/ProductJsonld.vue');
};

var ProductSheetTcVars = function ProductSheetTcVars() {
  return import(
  /* webpackChunkName: "product-seo-tracking" */
  '~/components/functional/TcVars/ProductSheetTcVars.vue');
};

var PendingTag = function PendingTag() {
  return import('~/components/functional/TcVars/PendingTag.vue');
};

export default {
  validate: function validate(_ref) {
    var alias = _ref.params.alias;
    return alias && extractProductReference(alias);
  },
  components: {
    ProductLoading: ProductLoading,
    SmartBanner: SmartBanner,
    CommercialRibbon: CommercialRibbon,
    SquareImage: SquareImage,
    MdmBreadcrumb: MdmBreadcrumb,
    ZoomableImage: ZoomableImage,
    ProductFlags: ProductFlags,
    ThePriceSection: ThePriceSection,
    TheVariantsSection: TheVariantsSection,
    ZoomModal: ZoomModal,
    ProductGlide: ProductGlide,
    Heart: Heart,
    ThumbnailList: ThumbnailList,
    ProductStock: ProductStock,
    TheEmailForm: TheEmailForm,
    TheCartSection: TheCartSection,
    StoreAvailability: StoreAvailability,
    Reinsurance: Reinsurance,
    ProductInformation: ProductInformation,
    CrossEarlyBirds: CrossEarlyBirds,
    ShopTheLook: ShopTheLook,
    Olapic: Olapic,
    ProductSeo: ProductSeo,
    JsonLd: JsonLd,
    OpenGraph: OpenGraph,
    ProductSheetTcVars: ProductSheetTcVars,
    PendingTag: PendingTag
  },
  fetch: function () {
    var _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref2) {
      var alias, query, store, error;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              alias = _ref2.params.alias, query = _ref2.query, store = _ref2.store, error = _ref2.error;
              registerStoreModule(store, 'product/', product);

              if (!process.server) {
                _context.next = 11;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return store.dispatch('product/fetchProduct', {
                alias: alias,
                query: query,
                useLatest: has(query, 'latest')
              });

            case 6:
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              error({
                statusCode: 404,
                message: 'Not Found'
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 8]]);
    }));

    function fetch(_x) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }(),
  asyncData: function asyncData() {
    return {
      serverFetch: process.server
    };
  },
  data: function data() {
    return {
      olapic: null,
      asyncStylesheetMedia: 'none',
      stockAlert: false,
      showModal: false,
      imageIndex: 0,
      mediumLower: true,
      productGlideEnabled: true,
      trackingWibilongActive: false,
      trackingWibilongDisplay: null
    };
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=600, public'
    };
  },
  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    productInspiration: 'product/productInspiration',
    productCross: 'product/productCross',
    productComplementary: 'product/productComplementary',
    product: 'product/product',
    currentImage: 'product/currentImage',
    variants: 'product/variants'
  }), {
    productName: function productName() {
      var prefix = '';

      if (this.product.line) {
        prefix = "".concat(this.product.line, " - ");
      }

      return "".concat(prefix).concat(this.product.name);
    },
    isWibilongAuthorized: function isWibilongAuthorized() {
      return this.locale.market === 'FR';
    },
    showProductCross: function showProductCross() {
      return this.productCross && this.productCross.products.length;
    },
    showProductComplementary: function showProductComplementary() {
      return this.productComplementary && this.productComplementary.products.length;
    },
    trackingWibilongClick: function trackingWibilongClick() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Click_conseil_utilisateur',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5, "/").concat(this.product.reference)
        }
      };
    },
    customizeProductUrl: function customizeProductUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/so-me-lampadaire?primary=").concat(this.product.reference, "&secondary=").concat(this.product.reference);
    },
    countryWithStores: function countryWithStores() {
      // const excludedMarkets = ['UK', 'PT', 'AT', 'NL'];
      // return excludedMarkets.filter((market) => market === this.locale.market).length === 0;
      var openStores = ['fr-FR', 'fr-BE', 'nl-BE', 'fr-CH', 'de-CH', 'it-CH', 'de-DE', 'fr-LU', 'it-IT', 'es-ES'];
      return openStores.includes(this.locale.iso);
    },
    sequraPredicate: function sequraPredicate() {
      if (this.locale.market === 'ES' && !this.product.isPro && this.actualPrice >= 50) return true;
      return false;
    },
    actualPrice: function actualPrice() {
      return this.product.price.sales.amount ? this.product.price.sales.amount : this.product.price.base.amount;
    },
    formattedBreadcrumb: function formattedBreadcrumb() {
      var _this = this;

      var result = [];

      if (this.product.additionalInformation.breadcrumbDisplay) {
        result = this.product.additionalInformation.breadcrumbDisplay.map(function (entry) {
          return {
            text: entry.label,
            to: entry.hash ? "".concat(_this.buildCategoryUrl(_this.locale, 'slug', entry.hash)) : '',
            href: entry.url ? "".concat(entry.url) : "".concat(_this.baseURL).concat(_this.buildCategoryUrl(_this.locale, 'slug', entry.hash))
          };
        });
      }

      return result;
    },
    hasAlertStockForm: function hasAlertStockForm() {
      return this.product.stock.status === 'SOON' && this.product.additionalInformation.pricesType === 'T' || this.stockAlert;
    },
    hasVariants: function hasVariants() {
      return this.variants.length;
    },
    isBuyable: function isBuyable() {
      return this.product.additionalInformation.buyable;
    },
    currentPath: function currentPath() {
      return "".concat(this.baseURL).concat(this.buildProductUrl(this.locale, this.product.slug, this.product.reference));
    },
    hasSlider: function hasSlider() {
      return this.isTablet() && this.product.images.length > 11 || this.isDesktop() && this.product.images.length > 5;
    },
    hasDeliveryReinsurance: function hasDeliveryReinsurance() {
      return this.product.stock.status === 'IN_STOCK' || this.product.stock.status === 'WEEK' || this.product.stock.status === 'MONTH' || this.product.stock.status === 'LIMITED';
    },
    hasReinsurance: function hasReinsurance() {
      return Boolean((this.product.additionalInformation.specialEvents.christmas_shipping || this.hasDeliveryReinsurance) && this.product.delivery);
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "productsheet";'
      };
      return luxConfig;
    },
    openGraphMetaDescription: function openGraphMetaDescription() {
      return this.product.additionalInformation.metaDescription || '';
    }
  }),
  created: function created() {
    var _this2 = this;

    registerStoreModule(this.$store, 'product/', product, true);

    if (process.client && !this.serverFetch) {
      var _this$$route = this.$route,
          alias = _this$$route.params.alias,
          query = _this$$route.query;
      var args = {
        alias: alias,
        query: query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '',
        useLatest: has(query, 'latest')
      };
      this.resetProduct();

      try {
        this.fetchProduct(args).then(function () {
          _this2.wibilong();
        });
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureException(error);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.serverFetch) {
      this.fetchCross();
    } else {
      this.createEbRecord();
    }

    this.bindScrollListener();
    this.stockAlert = this.$cookies.get('alertStock');
    this.mediumLower = !this.isDesktop();
  },
  destroyed: function destroyed() {
    this.unbindScrollListener();
  },
  methods: _objectSpread({}, mapMutations({
    resetProduct: 'product/RESET_PRODUCT'
  }), mapActions({
    fetchProduct: 'product/fetchProduct',
    fetchProductCarousels: 'product/fetchProductCarousels'
  }), {
    fetchCross: function fetchCross() {
      var _this3 = this;

      var crossPredicate = this.productCross && this.productCross.products && this.productCross.products.length;
      var args = {
        alias: this.$route.params.alias,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '',
        exclude: crossPredicate ? this.productCross.products.map(function (item) {
          return item.reference;
        }) : [],
        useLatest: has(this.$route.query, 'latest')
      };
      this.fetchProductCarousels(args).then(function () {
        _this3.createEbRecord();

        _this3.wibilong();
      });
    },
    createEbRecord: function createEbRecord() {
      var ebRecoIds = [];

      if (this.productCross) {
        var crossId = this.productCross.earlybirdsWidgets ? this.productCross.earlybirdsWidgets.id : null;
        ebRecoIds.push(crossId);
      }

      if (this.productComplementary) {
        var complementaryId = this.productComplementary.earlybirdsWidgets ? this.productComplementary.earlybirdsWidgets.id : null;
        ebRecoIds.push(complementaryId);
      }

      window.ebRecoIds = ebRecoIds;
    },
    emitGenericTrackingWibilong: function emitGenericTrackingWibilong() {
      this.$root.$emit('generic-tracking', {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_questions reponses_wibilong',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    },
    bindScrollListener: function bindScrollListener() {
      this.$root.$on('scroll-to-bottom', this.handleBottomBlocks);
      window.addEventListener('scroll', this.handleBottomBlocks, {
        passive: true
      });
    },
    unbindScrollListener: function unbindScrollListener() {
      this.$root.$off('scroll-to-bottom');
      window.removeEventListener('scroll', this.handleBottomBlocks);
    },
    handleBottomBlocks: function handleBottomBlocks() {
      this.olapic = 'olapic';
      this.unbindScrollListener();
    },
    wibilong: function wibilong() {
      var _this4 = this;

      if (this.isWibilongAuthorized) {
        this.asyncScript(WIBILONG_JS_URL).then(function () {
          _this4.trackingWibilongActive = true;
          _this4.trackingWibilongDisplay = {
            data: {
              event_category: 'FicheProduit',
              event_action: 'Display_conseil_utilisateur',
              event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5, "/").concat(_this4.product.reference)
            }
          };
        }).catch(function (err) {
          console.error('WIBILONG_JS_URL FAILED', err);
        });
      }
    },
    handleWibilong: function handleWibilong() {
      this.asyncStylesheetMedia = 'all';
    },
    handleClickDescription: function handleClickDescription(event) {
      try {
        var productInformation = this.$refs.productInformation;
        window.scrollTo({
          top: productInformation.$el.offsetTop - 100,
          behavior: 'smooth'
        });
      } catch (error) {
        console.log(error);
      }

      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_description',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    },
    openModal: function openModal() {
      this.showModal = true;
    },
    closeModal: function closeModal() {
      this.showModal = false;
    }
  }),
  head: function head() {
    return {
      link: [{
        rel: 'stylesheet',
        src: WIBILONG_CSS_URL,
        media: this.asyncStylesheetMedia,
        onload: this.handleWibilong
      }, {
        rel: 'prerender',
        url: "".concat(this.baseURL, "/").concat(this.locale.market, "/").concat(this.locale.language, "/panier.html")
      }, {
        rel: 'prerender',
        url: "".concat(this.baseURL, "/").concat(this.locale.market, "/").concat(this.locale.language, "/cart")
      }],
      script: [this.speedcurveConfig]
    };
  }
};